{
    "status": {
        "due": "Pendiente",
        "overdue": "Atrasado",
        "completed": "Completado"
    },
    "blankAnswer": "No indicado",
    "list": {
        "title": "Diarios",
        "emptyTitle": "Ningún diario por el momento",
        "emptyDescription": "Los diarios creados para usted aparecerán aquí",
        "checkAgain": "Comprobar de nuevo",
        "needsAttention": "Requiere su atención",
        "needsAttentionDesc": "Diarios cuyos formularios esperan su próximo registro.",
        "upToDate": "Al día",
        "ongoing": "En curso",
        "ongoingDesc": "Diarios en curso o a la espera de su primer registro.",
        "upToDateDesc": "Diarios en curso sin registros por cumplimentar.",
        "noOngoing": "Ningún diario en curso por el momento",
        "completed": "Completados",
        "completedDesc": "Diarios cerrados (ya no se recoge ningún registro).",
        "noCompleted": "Ningún diario completado por el momento",
        "openDiary": "Abrir el diario",
        "reviewDiary": "Consultar el diario"
    },
    "goToDiaries": {
        "title": "Ir a {{diaryWord}}",
        "actionRequiredCount": "Acción requerida ({{count}})",
        "actionRequiredOneForm": "Acción requerida ({{count}} formulario)",
        "actionRequiredManyForms": "Acción requerida ({{count}} formularios)",
        "defaultDescription": "Los diarios son sus seguimientos de salud personales y ayudan a mejorar los tratamientos y la investigación.",
        "oneFormDue": "Tiene {{count}} formulario por cumplimentar.",
        "manyFormsDue": "Tiene {{count}} formularios por cumplimentar.",
        "diariesNeedAttention": "Tiene {{count}} {{diaryWord}} cuyos formularios requieren su atención."
    }
}
